import React, { useCallback } from 'react';
import toast from 'react-hot-toast';
import {
  INVESTOR_ONBOARDING_TYPES,
  backToMethodSelection,
  startFreshOnboardingType,
} from '../../utils/investorOnboardingPersistence';
import useOnboardingPersistence from '../../hooks/useOnboardingPersistence';
import InvestorOnboardingMethodPage from './InvestorOnboardingMethodPage';
import InvestorOnboardingPage from './InvestorOnboardingPage';

/**
 * Renders method selection or the active onboarding flow at /investors/onboard.
 * All client state lives in localStorage via investorOnboardingPersistence.
 */
export default function InvestorOnboardEntryPage() {
  const { state } = useOnboardingPersistence();
  const onboardingType = state.onboardingType;

  const startManual = useCallback(() => {
    startFreshOnboardingType(INVESTOR_ONBOARDING_TYPES.MANUAL, {
      showErrorToast: (msg) => toast.error(msg),
    });
  }, []);

  const startAutomated = useCallback(() => {
    startFreshOnboardingType(INVESTOR_ONBOARDING_TYPES.AUTOMATED, {
      showErrorToast: (msg) => toast.error(msg),
    });
  }, []);

  const handleBackToMethodSelection = useCallback(() => {
    backToMethodSelection();
  }, []);

  if (
    onboardingType === INVESTOR_ONBOARDING_TYPES.MANUAL
    || onboardingType === INVESTOR_ONBOARDING_TYPES.AUTOMATED
  ) {
    return <InvestorOnboardingPage onBackToMethodSelection={handleBackToMethodSelection} />;
  }

  return (
    <InvestorOnboardingMethodPage
      onSelectManual={startManual}
      onSelectAutomated={startAutomated}
    />
  );
}
